import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import CommonCard from '../../../common/Pilots/CommonCard/CommonCard';
import './Engines.scss';	
import {VIRTUAL_CLASS_ROOM_OR_ENGINES_API_PATH} from '../../../../helper/APIPaths';
import { setData, setsubCategoryNameOrItemName } from '../../../../storage/reducers/virtualClassRoomOrEngines';
import CircularLoader from '../../../common/Loader/CircularLoader';
import { useTranslation } from 'react-i18next';
import { APP_TITLES, COMMON_MESSAGES, VIRTUAL_CLASSROOMS_AND_ENGINES_API_PARAMS } from '../../../../helper/constants';
import { isPilot } from '../../../../helper/commonFunctions';
import { setMenuSelection } from '../../../../storage/reducers/menuSelectorReducer';


const Engines: React.FC = ()=>{
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [elements, setElements] = useState<Array<any>>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [hasFetched, setHasFetched] = useState(false);
    const { dataCardEngines } = useSelector((state:any) => state.virtualClassRoomsOrEngines);
    const { userInformation } = useSelector((state: any) => state?.userInformation);
  
    useEffect(() => {
        if (dataCardEngines?.length > 0) {
            setElements(dataCardEngines);
            setLoading(false);
            setError(false);
        } else if (!hasFetched) {
          fetchEnginesElements();
          setHasFetched(true);
        }
        dispatch(setMenuSelection({currentMenuTitle: APP_TITLES.ENGINES}));
    }, [dataCardEngines]);

    const fetchEnginesElements = useCallback(async () => {
        try {
            const { subCategory, pilot_category_name_EN } = VIRTUAL_CLASSROOMS_AND_ENGINES_API_PARAMS;
            const response = await fetch(VIRTUAL_CLASS_ROOM_OR_ENGINES_API_PATH,{
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(
                    {
                        type:subCategory, 
                        pilot_category_name: pilot_category_name_EN,
                        role: isPilot(userInformation?.jobTitle || ""),
                    }
            ),
            });
            const res = await response.json();
            const data = res?.data;
            if (data) {
                const sortedData = data?.preflightData.sort((a, b) => {
                    if (a.id.toLowerCase() < b.id.toLowerCase()) return -1;
                    if (a.id.toLowerCase() > b.id.toLowerCase()) return 1;
                    return 0;
                });
                dispatch(setData({dataCardEngines:sortedData}));
                setLoading(false);
                setError(false);
            }
        } catch (ierror) {
            console.error("Error while fetching virtual classrooms data", ierror);
            setLoading(false);
            setError(true);
        }
    }, []);
        
    const handleElementClick = (element:any, index:number) => {
        dispatch(setsubCategoryNameOrItemName({subCategoryNameEngines: element?.id}));
        navigate(`/enginesList`);
    };

    const elementsList = elements?.map((element:any, index:number) => { 
        const updatedElement = {
            ...element, // copy all properties from the original element
            id: element?.id, // Overwrite `id` property
            title: `${element?.id} (${element?.value})`, // adds or overwrites `title` property
            type: "virtualclassrooms", // adds or overwrites `type` property
            action: () => handleElementClick(element, index), // defines the action to be performed on click
        };
        return <CommonCard key={index} {...updatedElement} />;
    });

    return (
        <div className='enginesContainer'>
            {loading && <CircularLoader />}
            {elements.length > 0 &&
                <div className='enginesList'>
                    {elementsList}
                </div>
            } 
            {(error || (!loading && elements.length === 0)) && (
                <div className='error'>{t(COMMON_MESSAGES.NO_DATA_AVAILABLE)}</div>
            )}
        </div>
       
    );
};

export default Engines;